import { getUserId } from "@/utils/getUesrKey";
import request from "project-config/services/request/request";
import { STORAGE } from "project-config/constants";
import { goToMainRoute } from "project-config/utils/env";
import QRCode from "@/service/qr-code";
import { saleSmartlyInstance } from "project-config/services";

export async function logoutHelper() {
  const { code } = await request.post("/api/rendering/user/userLogout", {});

  if (code === 200) {
    logoutHelperCommon();
  }
}

export async function logoutHelperCommon() {
  localStorage.setItem(STORAGE.PRE_USER_ID, getUserId());
  sessionStorage.setItem(STORAGE.HIDE_VERIFY_DIALOG, "0");
  sessionStorage.setItem(STORAGE.HIDE_STORAGE_DIALOG, "0");
  sessionStorage.removeItem(STORAGE.USER_KEY);
  QRCode.clearQRCode();
  saleSmartlyInstance.clearUserInfo();
  await request.post("/api/rendering/user/clearCookies", {
    cookieName: "rayvision_userKey",
  });
  goToMainRoute(false);
}
